import React, { useEffect, useState } from "react";
import api from "api";
import { useTranslation } from 'react-i18next';
import { debug, formatPrice, formatDate, download } from "utils";
import { FiPaperclip } from "react-icons/fi";
import OrderItems from "./../helpers/OrderItems";
export default function OrderDetailsModal({ orderId, onClose }) {
  const [loading, setLoading] = useState(false);
  const [order, setOrder] = useState(null);
  const [error, setError] = useState(null);
  const { t } = useTranslation();
  /* ===============================
     Load order details
  =============================== */
  useEffect(() => {
    const load = async () => {
      setLoading(true);
      setError(null);
      try {
        const res = await api.get(`/orders/${orderId}/details`);
        setOrder(res.data);
      } catch (e) {
        console.error(e);
        setError("Erreur lors du chargement");
      } finally {
        setLoading(false);
      }
    };
    load();
  }, [orderId]);



  return (
    <>
      <div className="modal fade show d-block">
        <div className="modal-dialog modal-xl modal-dialog-scrollable">
          <div className="modal-content">

            {/* HEADER */}
            <div className="modal-header">
              <h5 className="modal-title">
                Commande
              </h5>
              <button className="btn-close" onClick={onClose} />
            </div>

            {/* BODY */}
            <div className="modal-body">
              {loading && (
                <div className="text-center py-4">
                  <div className="spinner-border" />
                </div>
              )}
              {order && (
                <div className="container-fluid">
                  {/* INFOS */}
                  <div className="row mb-4">
                    <div className="col-md-4">
                      <h6>Informations</h6>
                      <div className="small">
                        <div><strong>Date :</strong> {formatDate(order.orderDate)}</div>
                        <div>
                          <strong>Status :</strong>{" "}
                          <span className={`${order.orderStatus === "paid"
                            ? "text-primary"
                            : "text-warning"
                            }`}>
                            {t(`order_status_${order.orderStatus}`)}
                          </span>
                        </div>
                      </div>
                    </div>
                    {/* BILLING */}
                    <div className="col-md-6 border">
                      <h6>Facturation</h6>
                      <div className="small">
                        <div><strong>{order.orderBillingCompany}</strong></div>
                        <div>{order.orderBillingFirstname} {order.orderBillingLastname}</div>
                        <div>{order.orderBillingAddress}</div>
                        <div>{order.orderBillingPostcode} {order.orderBillingCity}</div>
                        <div>{order.orderBillingCountry}</div>
                        <div>{order.orderBillingEmail}</div>
                      </div>
                    </div>
                    <div className="col-md-2 text-end">
                      {order.orderPDFFilename &&
                        <span className="text-primary small pointer decoration-on-over" onClick={() => download(`/orders/${order.orderId}/invoice/download`)}>
                          <FiPaperclip size={14} className="me-1" /> Facture PDF
                        </span>
                      }

                    </div>
                  </div>

                  {/* ITEMS */}
                  <div className="mb-4">
                    <h6>Détail</h6>

                    <OrderItems
                      items={order.items || []}
                      totalPriceET={order.orderTotalPriceET}
                      orderVATAmount={order.orderVATAmount}
                      totalPriceIT={order.orderTotalPriceIT}

                    />
                  </div>

                  {/* TOTAL */}
                  <div className="text-end">
                    <div className="fw-bold">
                      Total TTC : {formatPrice(order.orderTotalPriceIT)}
                    </div>

                    {parseFloat(order.orderBalance) > 0 && (
                      <div className="text-danger">
                        Reste à payer : {formatPrice(order.orderBalance)}
                      </div>
                    )}
                  </div>
                  {order.payments && order.payments.length > 0 && (
                    <div className="mb-4">
                      <h6>Paiements</h6>

                      <div className="table-responsive">
                        <table className="table table-sm align-middle">
                          <thead className="table-light">
                            <tr>
                              <th>Date</th>
                              <th>Mode</th>
                              <th>Montant</th>
                              <th>Statut</th>
                            </tr>
                          </thead>

                          <tbody>
                            {order.payments.map((pay) => (
                              <tr key={pay.payId}>
                                <td className="text-center">
                                  {pay.payCreatedAt
                                    ? new Date(pay.payCreatedAt).toLocaleString()
                                    : "-"}
                                </td>

                                <td className="text-capitalize text-center">
                                  {pay.payMode}
                                </td>

                                <td className="text-center">
                                  {formatPrice(pay.payAmount)} €
                                </td>

                                <td className="text-center">
                                  {pay.payFull === "1" ? (
                                    <span className="badge bg-success">
                                      Payé
                                    </span>
                                  ) : (
                                    <span className="badge bg-warning text-dark">
                                      Partiel
                                    </span>
                                  )}
                                </td>
                              </tr>
                            ))}
                          </tbody>
                        </table>
                      </div>
                    </div>
                  )}
                </div>
              )}

            </div>

            {/* FOOTER */}
            <div className="modal-footer">
              <button className="btn btn-secondary" onClick={onClose}>
                Fermer
              </button>
            </div>

          </div>
        </div>

      </div>

      <div className="modal-backdrop fade show"></div>
    </>
  );
}